import { Component, OnInit } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  FormArray,
  ValidatorFn,
  ValidationErrors,
  AbstractControl,
} from "@angular/forms";
import { AwsService } from "../../../providers/appsyncservice/aws.service";
import { UserTypePipePipe } from "../../../pipes/user-type-pipe.pipe";
import { positions } from "../../../models/positions";
declare var google: any;
import * as XLSX from "xlsx";
import * as jsPDF from "jspdf";
import { of } from "rxjs";

@Component({
  selector: "app-vendor-detail",
  templateUrl: "./vendor-detail.component.html",
  styleUrls: ["./vendor-detail.component.css"],
})
export class VendorDetailComponent implements OnInit {
  displayHouseValue: Number = 0;
  vendorlist: any = [];
  delID: any = [];
  mode: any = "add";
  checkboxCount = false;
  vendordataFm: FormGroup;
  submitted = false;
  countriesData = [];
  statusData: any = [
    { id: 1, name: "Active" },
    { id: 2, name: "InActive" },
  ];
  vendorType: any = [
    { id: 1, name: "Home" },
    { id: 2, name: "Car" },
    { id: 3, name: "Relocation" },
  ];

  sortKey: string = "sno"; //set default
  sortReverse: boolean = false;

  noOfItems = 10;
  private RELOCATION_VENDOR_COUNTRY_COUNT_DB_KEY =
    "RELOCATION_VENDOR_COUNTRY_COUNT";

  constructor(
    public awserviceProvider: AwsService,
    private formBuilder: FormBuilder
  ) {
    this.fetchCountriesFromDB();
    this.getAllData();
  }

  // GET DATA
  getAllData() {
    this.vendorlist = [];
    console.log("GET VENDOR LIST");
    this.awserviceProvider.getVendorlist().then((data) => {
      this.constructData(data);
      console.log("response", data);
    });
  }

  constructData(data) {
    this.vendorlist = [];
    var oplist = [];
    let responseData = data;
    responseData.sort((a, b) => {
      // Handle null/undefined dates
      if (!a.created_date && !b.created_date) return 0;
      if (!a.created_date) return 1; // Put items without dates at the end
      if (!b.created_date) return -1; // Put items without dates at the end

      // Convert dates to timestamps for comparison
      const dateA = new Date(a.created_date).getTime();
      const dateB = new Date(b.created_date).getTime();

      // Handle invalid dates
      if (isNaN(dateA) && isNaN(dateB)) return 0;
      if (isNaN(dateA)) return 1;
      if (isNaN(dateB)) return -1;

      return dateB - dateA; // Descending order (newest first)
    });
    for (var i in responseData) {
      responseData[i].sno = +i + 1;
      oplist.push(responseData[i]);
    }
    this.vendorlist = oplist;
    // console.log("vendorlist", this.vendorlist);
  }

  // ADD DATA
  add() {
    this.displayHouseValue = 1;
    this.mode = "add";
    this.formInitilization();
    console.log("this.vendordataFm.value", this.vendordataFm.value);
  }

  formInitilization() {
    // this.vendordataFm = new FormGroup({
    //   id: new FormControl(""),
    //   name: new FormControl(""),
    //   email: new FormControl(""),
    //   phone: new FormControl(""),
    //   address: new FormControl(""),
    //   vendor_type: new FormControl(""),
    //   is_active: new FormControl("")
    // });

    this.vendordataFm = this.formBuilder.group({
      id: [""],
      name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      // phone: ["", [Validators.required, Validators.pattern("[0-9]{10}")]],
      phone: ["", Validators.required],
      address: ["", Validators.required],
      vendor_type: ["", Validators.required],
      is_active: ["", [Validators.required, Validators.min(1)]],
      countries: new FormArray([], this.minSelectedCheckboxes(1)),
    });
    of(this.getCountries()).subscribe((countries) => {
      this.countriesData = countries;
      this.addCheckboxes();
    });
  }

  editFormInitilization() {
    this.vendordataFm = this.formBuilder.group({
      id: [""],
      name: ["", Validators.required],
      email: ["", [Validators.required, Validators.email]],
      // phone: ["", [Validators.required, Validators.pattern("[0-9]{10}")]],
      phone: ["", Validators.required],
      address: ["", Validators.required],
      vendor_type: ["", Validators.required],
      is_active: ["", [Validators.required, Validators.min(1)]],
      countries: new FormArray([], this.minSelectedCheckboxes(1)),
    });
    of(this.getCountries()).subscribe((countries) => {
      this.countriesData = countries;
      //this.addCheckboxes();
    });
  }

  minSelectedCheckboxes(min = 1) {
    return (control: AbstractControl): ValidationErrors | null => {
      if (!(control instanceof FormArray)) {
        return null;
      }

      const totalSelected = control.controls.filter(
        (control) => control.value
      ).length;

      this.checkboxCount = totalSelected === 0;

      return totalSelected >= min ? null : { required: true };
    };
  }

  get f() {
    return this.vendordataFm.controls;
  }

  // EDIT DATA
  editData(vendorDt) {
    console.log("editData", vendorDt);
    this.editFormInitilization();
    this.displayHouseValue = 1;
    this.submitted = false;
    this.mode = "edit";
    // this.vendordataFm.setValue({
    //   id: vendorDt.id,
    //   name: vendorDt.name,
    //   email: vendorDt.email,
    //   phone: vendorDt.phone,
    //   address: vendorDt.address,
    //   vendor_type: vendorDt.vendor_type,
    //   is_active: vendorDt.is_active
    // });

    this.f["id"].setValue(vendorDt.id);
    this.f["name"].setValue(vendorDt.name);
    this.f["email"].setValue(vendorDt.email);
    this.f["phone"].setValue(vendorDt.phone);
    this.f["address"].setValue(vendorDt.address);
    this.f["vendor_type"].setValue(vendorDt.vendor_type);
    this.f["is_active"].setValue(vendorDt.is_active);

    //console.log("this.f.controls")
    //console.log(this.f.controls);
    //console.log("vendorDt.ex_data: ", vendorDt.ex_data);

    const countriesFormArray = this.vendordataFm.get('countries') as FormArray;
    this.countriesData.forEach(localCheckBox => {
      countriesFormArray.push(
        new FormControl(vendorDt.ex_data && vendorDt.ex_data.includes(localCheckBox))
      );
    });
    /* checkbox Value */
    // this.countriesData.map((localCheckBox) => {
    //   console.log("localCheckBox", localCheckBox);
    //   if (vendorDt.ex_data.includes(localCheckBox)) {
    //     (this.vendordataFm.controls.countries as FormArray).push(
    //       new FormControl(true)
    //     );
    //   } else {
    //     (this.vendordataFm.controls.countries as FormArray).push(
    //       new FormControl(false)
    //     );
    //   }
    // });
    /* checkbox Value */
  }

  getCountries() {
    return this.countriesData;

    // return [
    //   "France", "Bucharest", "Shenyang", "Wuhan", "Rabat",
    //   "Japan",
    //   "Others",
    // ];
  }

  fetchCountriesFromDB() {
    var templist = [];
    this.awserviceProvider
      .getMiscData(this.RELOCATION_VENDOR_COUNTRY_COUNT_DB_KEY)
      .then((res) => {
        //console.log("-----> getCountries called")
        //console.log("-----> getCountries: ")
        //console.log(res[0].data_value);

        //var countryArr = JSON.parse(res[0].data_value);
        var countryArr = res[0].data_value;

        this.countriesData = [];
        for (var i in countryArr) {
          templist.push(countryArr[i].name);
          console.log("index:", i);
          console.log(countryArr[i].name);
        }
        this.countriesData = templist;
        //console.log("templist")
        //console.log(templist)
      })
      .catch((err) => {
        console.log("getCountries-err", err);
        console.log(err);
      });
  }

  addCheckboxes() {
    this.getCountries().forEach((o, i) => {
      // console.log("0", o.id);
      // const control = new FormControl(i === 0); // if first item set to true, else false
      (this.vendordataFm.controls.countries as FormArray).push(
        new FormControl(false)
      );
    });
  }

  // SAVE DATA
  onSubmit() {
    this.submitted = true;

    const selectedCountries = this.vendordataFm.value.countries
      .map((v, i) => (v ? this.countriesData[i] : null))
      .filter((v) => v !== null);
    //console.log("-----> selectedCountries", selectedCountries);
    this.vendordataFm.value.selectedCountries = selectedCountries;

    if (this.vendordataFm.invalid) {
      return;
    }

    console.log("Add - car data", this.vendordataFm.value.id);
    if (this.vendordataFm.value.id !== "") {
      // # UPDATE RECORD #
      this.awserviceProvider
        .UpdateVendorData(this.vendordataFm.value)
        .then((result) => {
          this.getAllData();
          this.resertForm();
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      // # CREATE RECORD #
      this.awserviceProvider
        .CreateVendorData(this.vendordataFm.value)
        .then((result) => {
          this.getAllData();
          this.resertForm();
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  }

  resertForm() {
    this.submitted = false;
    this.displayHouseValue = 0;
    this.vendordataFm.reset();
    this.vendordataFm.markAsUntouched();
    this.vendordataFm.markAsPristine();
  }

  deletePopup(vendorDt) {
    this.delID = vendorDt.id;
  }
  // REFER FROM SC-USER-TRIP - (MASTER)
  deleteData(vendorDt) {
    console.log("vendorDt", vendorDt);
    this.awserviceProvider
      .deleteVendorData(vendorDt)
      .then((res) => {
        this.delID = "";
        console.log("DeleteID", this.delID);
        this.getAllData();
      })
      .catch((err) => {
        console.log(err);
      });
  }

  ngOnInit() {
    this.displayHouseValue = 0;
    this.formInitilization();
    console.log("Vendor data module init");
  }

  public sort(sortKey) {
    this.sortKey = sortKey;
    this.sortReverse = !this.sortReverse;
  }

  public sortClass(sortKey) {
    if (this.sortKey == sortKey) {
      if (this.sortReverse) {
        return "fa fa-sort-desc";
      } else {
        return "fa fa-sort-asc";
      }
    } else {
      return "fa fa-sort";
    }
  }
}
